/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
import React, { useMemo } from 'react';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import PropTypes from 'prop-types';
import { FormattedMessage } from '@jutro/locale';
import { Link } from '@jutro/components'; // Jutro's Link for navigation
import metadata from './EmailNotificationComponent.metadata.json5';
import messages from './EmailNotificationComponent.messages';

function EmailNotificationComponent({ notifications, onPolicyClick }) {
    const generateOverrides = useMemo(() => {
        return {
            emailNotification: {
                message: (
                    <FormattedMessage
                        {...messages.notificatonText}
                        values={{
                            link: (
                                <span>
                                    {notifications.map((policyNumber, index) => {
                                        const isLast = index === notifications.length - 1;
                                        const isSecondLast = index === notifications.length - 2;
                                        // eslint-disable-next-line no-nested-ternary
                                        const separator = isLast ? '' : isSecondLast ? ' and ' : ', ';
                                        return (
                                            <span key={policyNumber}>
                                                <Link
                                                    // eslint-disable-next-line indent
                                                    href="#"
                                                    onClick={(event) => {
                                                        event.preventDefault();
                                                        onPolicyClick(event, policyNumber);
                                                    }}
                                                >
                                                    {policyNumber}
                                                </Link>
                                                {separator}
                                            </span>
                                        );
                                    })}
                                </span>
                            )
                        }}
                    />
                )
            }
        };
    }, [notifications, onPolicyClick]);

    const overrideProps = {
        ...generateOverrides
    };

    return renderContentFromMetadata(metadata.pageContent, overrideProps);
}

EmailNotificationComponent.propTypes = {
    notifications: PropTypes.arrayOf(PropTypes.string), // Array of policy number strings
    onPolicyClick: PropTypes.func.isRequired // Callback function to handle policy click
};

EmailNotificationComponent.defaultProps = {
    notifications: []
};

export default EmailNotificationComponent;
